import { useState, useEffect, useCallback } from "react";
import { useFilterContext } from "../../ContextManager";
import FilterTooltip from "../../UX/FilterTooltip/FilterTooltip";
import { CustomSlider } from "../../UX/CustomSlider/CustomSlider";
import { debounce, timeConverter } from "../../../utils/utilityFunctions";

// MUI
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { Slider, Typography } from "@mui/material";

import style from "../../../css/modalAdvancedSettings.module.css";

export const AdvancedSettingsModal = () => {
  const {
    passengerLoadFactor,
    updatePassengerLoadFactor,
    filters,
    updateFilters,
  } = useFilterContext();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [sliderValues, setSliderValues] = useState({
    speed: filters.speed,
    departure: filters.departure,
    arrival: filters.arrival,
  });

  const [localValue, setLocalValue] = useState(passengerLoadFactor * 100);

  // convert 0–1 value into a 0–100 slider position
  const sliderValue = passengerLoadFactor * 100;

  // sync if context value changes from elsewhere
  useEffect(() => {
    setLocalValue(passengerLoadFactor * 100);
  }, [passengerLoadFactor]);

  //   const handleSliderChange = (event, value) => {
  //     // `value` is a number 0–100
  //     const newLoadFactor = value / 100;
  //     updatePassengerLoadFactor(newLoadFactor);
  //   };

  useEffect(() => {
    setSliderValues({
      ...sliderValues,
      speed: filters.speed,
      departure: filters.departure,
      arrival: filters.arrival,
    });
  }, [filters.speed, filters.departure, filters.arrival]);

  const updateSliderValue = (newValue, keys) => {
    let newSliderValues = { ...sliderValues };
    keys.forEach((key, i) => {
      newSliderValues[key] = newValue[i];
    });
    setSliderValues(newSliderValues);
  };

  const debounceOnSliderChangeComitted = useCallback(
    debounce((newValue, keys) => {
      let newFilterValues = { ...filters };
      keys.forEach((key, i) => {
        newFilterValues[key] = newValue[i];
      });
      updateFilters(newFilterValues);
    }, 250)
  );

  const onSliderChangeCommitted = (newValue, keys) => {
    // Update filters state when slider change is committed
    debounceOnSliderChangeComitted(newValue, keys);
  };

  return (
    <div>
      <p onClick={handleOpen} className={style.settingsLink}>
        Advanced Settings
      </p>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-advanced-settings"
        slotProps={{
          backdrop: {
            className: style.backdrop,
          },
        }}
      >
        <Box className={style.modal}>
          {/* 
          <div className={style.header}>
            <h1>Advanced Settings</h1>
            <IconButton
              aria-label="close menu"
              size="small"
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className={style.mainTextWrapper}>
            <Typography gutterBottom>
              Passenger Load Factor (CO<sub>2</sub> Emissions):{" "}
              {Math.round(sliderValue)}%
            </Typography>
            <Slider
              value={localValue}
              onChange={(e, v) => setLocalValue(v)}
              onChangeCommitted={(_, v) => updatePassengerLoadFactor(v / 100)}
              valueLabelDisplay="auto"
              valueLabelFormat={(v) => `${Math.round(v)}%`}
              min={0}
              max={100}
              step={1}
            />
          </div>
        </Box> */}
          <div>
            <div className={style.flexBetween}>
              <FilterTooltip id="speed">
                <span>Flight Speed</span>
              </FilterTooltip>
              <p>{filters.speed} km/h</p>
            </div>
            <CustomSlider
              sliderValue={[sliderValues.speed]}
              filterKeys={["speed"]}
              updateSliderValue={updateSliderValue}
              onSliderChangeCommitted={onSliderChangeCommitted}
              step={5}
              min={50}
              max={500}
            />
          </div>
          <div>
            <div className={style.flexBetween}>
              <FilterTooltip id="departure">
                <span>Airport Time (Departure)</span>
              </FilterTooltip>
              <p>{timeConverter(filters.departure)}</p>
            </div>
            <CustomSlider
              sliderValue={[sliderValues.departure]}
              filterKeys={["departure"]}
              updateSliderValue={updateSliderValue}
              onSliderChangeCommitted={onSliderChangeCommitted}
              step={5}
              max={120}
            />
          </div>
          <div>
            <div className={style.flexBetween}>
              <FilterTooltip id="arrival">
                <span>Airport Time (Arrival)</span>
              </FilterTooltip>
              <p>{timeConverter(filters.arrival)}</p>
            </div>
            <CustomSlider
              sliderValue={[sliderValues.arrival]}
              filterKeys={["arrival"]}
              updateSliderValue={updateSliderValue}
              onSliderChangeCommitted={onSliderChangeCommitted}
              step={5}
              max={120}
            />
          </div>
        </Box>
      </Modal>
    </div>
  );
};
